import { Injectable, NgZone  } from '@angular/core';
import { Auth, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider, OAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from '@angular/fire/auth';
// setPersistence must NOT come from @angular/fire/auth: its ɵzoneWrap wrapper zone-wraps any
// argument that is typeof 'function' (to support callback-style APIs like onSnapshot), and ES6
// classes are typeof 'function' too — so it corrupts the browserLocalPersistence/
// browserSessionPersistence class argument before Firebase ever sees it. Use the raw firebase/auth
// exports for all three so the persistence class reaches Firebase unmodified.
import { setPersistence, browserLocalPersistence, browserSessionPersistence } from 'firebase/auth';
import { of } from 'rxjs';
import { Firestore } from '@angular/fire/firestore';
import { ApiserviceService } from 'src/app/services/apiservice.service';
import { Observable } from "rxjs/index";
import { NotificationService } from '../services/notification.service';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  userData: any;
  userExists:boolean = false;

  // When Remember Me is off, the login should not survive closing the browser/tab.
  // sessionStorage is cleared automatically on browser/tab close, unlike localStorage,
  // so it's used as the signal for "is this still the same browser session".
  private readonly SESSION_ONLY_KEY = 'session_login_only';

  constructor(
    public afs: Firestore,   // Inject Firestore service
    public afAuth: Auth, // Inject Firebase auth service
    public router: Router,
    public translateService: TranslateService,
    private apiService: ApiserviceService,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    public toast:NotificationService
  ) { }


  // --------------------------ADMIN------------------------------
  AdminSetToken(token:string) :void {
    localStorage.setItem('adminToken',token);
  }

  AdminGetToken() : string | null {
    return localStorage.getItem('adminToken'); 
  }

  AdminIsLoggedIn(): boolean {
    return (this.AdminGetToken() !== null) ? true : false;
  }

  AdminLogout(){
    localStorage.removeItem('adminToken');
    this.router.navigate(['/admin/admin-login']);
  }

  adminLogin({username, password}:any): Observable<any>{
    if(username === 'admin' && password === 'mtc@2022'){
      this.AdminSetToken('adminLogin');
      return of({success: 1, message: 'Login Successfully' })
    }
    else
    {
      return of({success: 0, message: 'Faild to login' })
    }
  }


  // ----------------END ADMIN-------------------------------


  

  GoogleAuth() {
    return new Promise<any>((resolve, reject) => {
      const provider = new GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
      signInWithPopup(this.afAuth, provider)
        .then(res => {
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
    })
  }


  doFacebookLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new FacebookAuthProvider();
      signInWithPopup(this.afAuth, provider)
        .then(res => {
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
    })
  }


  doAppleLogin() {
    return new Promise<any>((resolve, reject) => {
      const provider = new OAuthProvider('apple.com');
      signInWithPopup(this.afAuth, provider)
        .then(res => {
          resolve(res);
        }, err => {
          console.log(err);
          reject(err);
        })
    })
  }


  doRegister(value:any) {
    return new Promise<any>((resolve, reject) => {
      createUserWithEmailAndPassword(this.afAuth, value.email, value.password)
        .then(res => {
          // this.SendVerificationMail();
          resolve(res);
        }, err => reject(err))
    })
  }
  

  doLogin(value:any, rememberMe: boolean = true) {
    return new Promise<any>((resolve, reject) => {
      setPersistence(this.afAuth, rememberMe ? browserLocalPersistence : browserSessionPersistence)
        .then(() => signInWithEmailAndPassword(this.afAuth, value.email, value.password))
        .then((res:any) => {
        
          // if (res.user.emailVerified == false) {
          //   this.SendVerificationMail();
          //   this.toast.showInfo('',this.translateService.instant('validate_your_mail_address'));
          //   window.alert('Please validate your email address. Kindly check your inbox.');
          // } 
          // else 
          // {
          //   resolve(res);
          //   // this.ngZone.run(() => {
          //   //   this.router.navigate(['create-transfer']);
          //   // });
          // }
          // this.loggedIn.next(true);
          resolve(res);
        }, err => reject(err))
    })
  }

  SendVerificationMail() {
    const currentUser = this.afAuth.currentUser;
    if (currentUser) {
      // Email verification logic here if needed
      console.log('Send verification mail');
    }
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail: string) {
    return sendPasswordResetEmail(this.afAuth, passwordResetEmail)
    .then(() => {
      this.toast.showSuccess(this.translateService.instant('we_have_send_you_reset_password_email'),this.translateService.instant('reset_email_send_successfully'));
      // window.alert('Password reset email sent, check your inbox.');
    }).catch((error: any) => {
      return error;
      window.alert(error)
    })
 }

  setToken(token:string, rememberMe: boolean = true) :void {
    localStorage.setItem('uid',token);
    if (rememberMe) {
      localStorage.removeItem(this.SESSION_ONLY_KEY);
      sessionStorage.removeItem(this.SESSION_ONLY_KEY);
    } else {
      // Marked in both storages: localStorage records that THIS login was session-only
      // (survives page refresh via sessionStorage), sessionStorage is the part that
      // actually disappears when the browser/tab closes.
      localStorage.setItem(this.SESSION_ONLY_KEY, 'yes');
      sessionStorage.setItem(this.SESSION_ONLY_KEY, 'yes');
    }
  }

  getToken() : string | null {
    return localStorage.getItem('uid');
  }


  isLoggedIn(): boolean {
    if (this.getToken() === null) {
      return false;
    }
    const isSessionOnly = localStorage.getItem(this.SESSION_ONLY_KEY) === 'yes';
    if (isSessionOnly) {
      // Remember Me was off. sessionStorage only survives within the same browser
      // session/tab — if it's gone, the browser (or this tab) was closed and reopened.
      return sessionStorage.getItem(this.SESSION_ONLY_KEY) === 'yes';
    }
    return true;
  }

  // Browsers do NOT clone sessionStorage into a tab opened via target="_blank"/window.open
  // (confirmed empirically, not just per-spec ambiguity) — only localStorage is shared.
  // When Remember Me is off, the login flag lives only in sessionStorage, so a plain
  // target="_blank" link to a guarded route bounces straight to login in a fresh tab.
  // Opening the tab via window.open() gives us a synchronous handle to it before it
  // navigates, so we can copy the flag across first.
  openInNewTabPreservingSession(url: string): void {
    const newTab = window.open('', '_blank');
    if (newTab) {
      try {
        const sessionOnly = sessionStorage.getItem(this.SESSION_ONLY_KEY);
        if (sessionOnly) {
          newTab.sessionStorage.setItem(this.SESSION_ONLY_KEY, sessionOnly);
        }
      } catch { /* cross-origin or storage access denied; fall through and navigate anyway */ }
      newTab.location.href = url;
    } else {
      // Popup blocked — fall back to normal same-tab-triggered new tab (session flag
      // will still be missing there, but this only happens if window.open is blocked).
      window.open(url, '_blank');
    }
  }


  logout(){
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('uid');
      localStorage.removeItem(this.SESSION_ONLY_KEY);
      sessionStorage.removeItem(this.SESSION_ONLY_KEY);
      this.router.navigate(['login']);
    })
  }

  logoutBusiness(){
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('uid');
      localStorage.removeItem(this.SESSION_ONLY_KEY);
      sessionStorage.removeItem(this.SESSION_ONLY_KEY);
      this.router.navigate(['business-login']);
    })
  }
}
